/**
 * orga-app-api - veranstaltungen-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VeranstaltungenBenutzerZugriff { 
    benutzer_id: string;
    ist_funktionsbereich_admin?: boolean;
    ist_veranstaltungsleiter?: boolean;
    ist_backend_admin?: boolean;
    ist_funkprotokoll_benutzer?: boolean;
    ist_funkprotokoll_lesen_benutzer?: boolean;
    darf_funkprotokoll_loeschen?: boolean;
    ist_veranstaltungstyp_admin?: boolean;
    darf_aufgaben_benutzer_berechtigungen_verwalten?: boolean;
    mandant_id: string;
    modified_on_utc: Date;
}

